import React, { Component } from 'react';
import {Route, withRouter, Redirect,Switch, BrowserRouter as Router} from 'react-router-dom';
import authClient from './Auth';
import './App.css';
// test signUp
import FirebaseSignupFunctional from './Components/FirebaseSignupFunctional';
import WriteReviewFunctional from './Components/WriteReviewFunctional';
import WriteReviewFunctionalSearch from './Components/WriteReviewFunctionalSearch';
// testSignUp End
import Callback from './Callback';
import NavBar from './NavBar/NavBar';
import Rate from './Components/Rate';
// test import
import Ratee from './Components/Ratee';
// text import end
import Login from './Components/FirebaseLogin';
import Search from './Components/Search';
import WriteReview from './Components/WriteReview';
import SignUp from './Components/FirebaseSignup';
import { auth } from './Services/firebase';
import About from './Components/About';
import BusinessInsights from './Components/BusinessInsights';
import Contact from './Components/Contact/Contact';
import Legal from './Components/Legal';
import UserGuide from './Components/UserGuide';
import Home from './Components/Home/home';
import { Footer } from './Components/Footer/Footer';
import { BusinessDescription } from './Components/BusinessDescription/BusinessDescription';
import AddListing from './Components/AddListing/AddListing';
import { UserProfile } from './Components/UserProfile/UserProfile';
import { AllListing } from './Components/AllListings/AllListing';
import ContactUs from './Components/contactUs/contactUs';
import { BusinessDetails } from './Components/admin/dashboard/businessDetails';
import { AdminDashboard } from './Components/admin/dashboard/adminDashboard';
import { AdminAllListings } from './Components/admin/allListing/AllListing';
import { AdminUsers } from './Components/admin/users/users';
import { AdminReviews } from './Components/admin/reviews/AdminReviews';
import { AdminReviewsDetail } from './Components/admin/reviewDetail/reviewDetail';
import { AdminReviewsUpdate } from './Components/admin/reviewDetail/updateReview';
import {UserProfileNew}   from './Components/UserProfile/UserProfileNew';

function PrivateRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authenticated === true
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />}
    />
  )
}

function PublicRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authenticated === false
        ? <Component {...props} />
        // : <Redirect to='/rate-company' />}
        :<Redirect to='/' />}
    />
  )
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //checkingSession: true,
      authenticated: false,
      loading: true,
      user:{}
    }
  }

  /* async componentDidMount() {
    if (this.props.location.pathname === '/callback') {
      this.setState({checkingSession:false});
      return;
    }
    try {
      await authClient.silentAuth();
      this.forceUpdate();
    } catch (err) {
      if (err.error !== 'login_required') console.log(err.error);
    }
    this.setState({checkingSession:false});
  } */

  componentDidMount() {
    auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authenticated: true,
          loading: false,
          user:user
        });
        // console.log(this.state.user);

      } else {
        this.setState({
          authenticated: false,
          loading: false,
        });
      }
    })
  }
  render() {
    return this.state.loading === true ? <h2>Loading...</h2> :(
       <div>
          <Router>
            <>
            {this.state.user.displayName == "admin"?
            <>
             <Switch>
              <Route exact path='/admin/dashboard' component={AdminDashboard} />
              <Route exact path='/admin/listings' component={AdminAllListings} />
              <Route exact path='/admin/users' component={AdminUsers} />
              <Route exact path='/admin/reviews' component={AdminReviews} />
              <Route exact path='/admin/reveiw-detail' component={AdminReviewsDetail} />
              <Route exact path='/admin/update-reveiw' component={AdminReviewsUpdate} />
              <Route exact path='/admin/business-details' component={BusinessDetails} />
  
               <Route exact path='/admin/addlisting' component={AddListing} />
               <Route exact path='/userprofile' component={UserProfile}/>
               
              
              <Route path='*' >
                <Redirect to="/admin/dashboard" />
              </Route>
            </Switch>
            </>
            :
            <>
              <NavBar/> 
            <Switch>
              <Route exact path='/' component={Home}/>
              <Route exact path='/addlisting' component={AddListing} />
              <Route exact path='/description/:id' component={BusinessDescription}/>
              {/* <Route exact path='/userprofile' component={UserProfile}/> */}
              <Route exact path='/userprofile/test' component={UserProfileNew}/>
              <Route exact path='/all-listing' component={AllListing}/>
              <Route exact path='/contactus' component={ContactUs}/>
              {/* <Route exact path='/rate' component={Rate}/> */}
              <Route exact path='/rate/:id' authenticated={this.state.authenticated} component={Ratee}/>
              <Route exact path='/search' component={Search}/>
              <PublicRoute path="/login" authenticated={this.state.authenticated} component={Login} />
              {/* <Route exact path='/review' component={WriteReview}/> */}
              <Route exact path='/review' component={WriteReviewFunctional}/>
              <Route exact path='/test/review' component={WriteReviewFunctional}/>
              <Route exact path='/SearchSpecific/:id' component={WriteReviewFunctionalSearch}/>
              <Route exact path='/about' component={About}/>
              <Route exact path='/user-guide' component={UserGuide}/>
              <Route exact path='/legal' component={Legal}/>
              <Route exact path='/contact' component={Contact}/>
              <Route exact path='/testSignup' component={FirebaseSignupFunctional}/>
              <PrivateRoute path='/company-rate/:companyId' authenticated={this.state.authenticated} component={Ratee}/>
              {/* <PrivateRoute path='/rate-company/:companyId' authenticated={this.state.authenticated} component={Rate}/> */}
              {/* <PublicRoute path="/signup" authenticated={this.state.authenticated} component={SignUp}></PublicRoute> */}
            </Switch>
            <Footer />
            </>
            }
           

          
            </>
          </Router>
     </div>
    );
  }
}

export default withRouter(App);
